module.exports = __webpack_public_path__ + "img/Middey_Horizontal.c44e80e0.png";